module.exports = __webpack_public_path__ + "static/media/union-icon.06efd874.svg";